export default "__VITE_ASSET__DypcQwrY__"